/**
 * Nguồn hình thành QLTS
 */
export default {
  BudgetState: 1, // Nguồn NSNN
  AirSource: 2, // Nguồn viện trợ, vay nợ nước ngoài
  RemainingSource: 3, // Nguồn phí được khấu trừ để lại
  WelfareFund: 4, // Quỹ phúc lới
  FoundationForCareer: 5, // Quỹ phát triển hoạt động sự nghiệp
  BusinessCapital: 6, // Nguồn vốn kinh doanh
  OtherSource: 7, // Nguồn khác
  OfferingSource: 8, // Nguồn viện trợ, tài trợ, biếu tặng nhỏ lẻ
  BudgetODA: 9 // nguồn ODA
};
